import { ButtonHook } from 'common/Prose/Toolbar/Types'
import { timedOutToggleMark } from 'common/Prose/Toolbar/utils/util'
import { computed } from 'mobx'
import { schema } from 'prose-core'
import { EditorView } from 'prosemirror-view'
import { useContext } from 'react'
import { AlmanacEditorStateContext } from 'stores/EditorState'
import { PressEvent } from '@react-types/shared/src/events'

export function useBoldToggle(view: EditorView): ButtonHook<(e: PressEvent) => void> {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const almanacState = useContext(AlmanacEditorStateContext)!

  const hasBold = computed(() => almanacState.activeMarks.has(schema.marks.strong)).get()

  const hasCodeBlock = computed(() => almanacState.activeNodes.has(schema.nodes.code_block)).get()

  return { active: hasBold, handleClick: timedOutToggleMark(schema.marks.strong, view), disabled: hasCodeBlock }
}
